import {useCallback, useEffect, useRef, useState} from 'react'
import {Navigate, useParams, useSearchParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {ColaEnCurso} from '@/components/bateria/cola/cola-en-curso'
import {useIsSystemUser} from '@/hooks/empresa/organizacion/use-businesses'
import {useEvaluacionDetail} from '@/hooks/bateria/use-bateria'
import {firmaDeFiltros, leerFiltros} from '@/lib/cola-filtros'

/** `ColaEnCurso` se remonta con la firma de los filtros para que el cursor nazca de cero sobre la lista nueva. */
export function AdminBateriaColaPage() {
  const {t} = useTranslation()
  const {businessId, evaluacionId} = useParams<{businessId: string; evaluacionId: string}>()
  const [searchParams] = useSearchParams()
  const isSystemUser = useIsSystemUser()
  const {data: detalle} = useEvaluacionDetail(businessId, evaluacionId, true)

  const filtros = leerFiltros(searchParams)
  const firma = firmaDeFiltros(filtros)

  // Vive fuera de `ColaEnCurso` porque tiene que sobrevivir a su remontaje.
  const [colaNueva, setColaNueva] = useState(false)
  const firmaPrevia = useRef(firma)
  useEffect(() => {
    if (firmaPrevia.current === firma) return
    firmaPrevia.current = firma
    setColaNueva(true)
  }, [firma])
  const alMoverElCursor = useCallback(() => setColaNueva(false), [])

  if (!isSystemUser || !businessId || !evaluacionId) return <Navigate to="/" replace />

  const volverA = `/admin/bateria/empresas/${businessId}/evaluaciones/${evaluacionId}`
  const paquetes = detalle?.paquetes ?? []
  const sujeto =
    filtros.paqueteIds.length === 1
      ? (paquetes.find((p) => p.id === filtros.paqueteIds[0])?.employee_name ?? t('admin.bateria.cola.persona'))
      : filtros.paqueteIds.length > 1
        ? t('admin.bateria.cola.personasSeleccionadas', {count: filtros.paqueteIds.length})
        : t('admin.bateria.cola.lote.nombre')

  return (
    <div className="mx-auto max-w-3xl space-y-4 pb-24 md:pb-0" data-testid="bateria-cola">
      <ColaEnCurso
        key={firma}
        businessId={businessId}
        evaluacionId={evaluacionId}
        filtros={filtros}
        volverA={volverA}
        rutaCola={`${volverA}/revision`}
        sujeto={sujeto}
        avisoDeColaNueva={colaNueva}
        onCursorMovido={alMoverElCursor}
      />
    </div>
  )
}
